import { useEffect } from "react";

const BootstrapModal = ({
  id,
  title,
  showModal,
  children,
  onClose,
  onSave,
}) => {
  useEffect(() => {
    // Close modal on escape key press
    const escHandler = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    // document.addEventListener("keydown", escHandler);
    // return () => document.removeEventListener("keydown", escHandler);
  }, [onClose]);

  if (!showModal) return null;
  return (
    <div
      className={`modal fade ${showModal ? "show active" : ""}`}
      id={id}
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">{children}</div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Close
            </button>
            {onSave && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onSave}
              >
                Save changes
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BootstrapModal;
